<template>
  <div class="main-content">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="heading mb-3">
            <h1 v-if="userData && userData.team_id">Documents</h1>
            <h1 v-else>Personal Documents</h1>
            <p
              v-if="
                userData && userData.team_id && $route.query.doc_type != 'team'
              "
            >
              These are your private documents within the
              <strong>{{ userData.team.name }}</strong> team.
            </p>
            <p
              v-if="
                userData && userData.team_id && $route.query.doc_type == 'team'
              "
            >
              These are the documents shared by all
              <strong>{{ userData.team.name }}</strong> team members.
            </p>
          </div>
        </div>
      </div>

      <div
        class="doc-types"
        v-if="userData && userData.team_id && DocsData.team_counts"
      >
        <ul>
          <li
            :class="{ active: $route.query.doc_type == 'personal' }"
            @click="
              $router.push({
                path: 'documents',
                query: { doc_type: 'personal' },
              })
            "
          >
            Private {{ DocsData.team_counts.personal }}
          </li>
          <li
            :class="{ active: $route.query.doc_type != 'personal' }"
            @click="
              $router.push({ path: 'documents', query: { doc_type: 'team' } })
            "
          >
            Team {{ DocsData.team_counts.team }}
          </li>
        </ul>
      </div>

      <div class="row" v-if="(filteredItems && filteredItems.length) || search">
        <div class="col-12">
          <div class="filter-bar filter-full">
            <div class="search-box-right">
              <a href="javascript:;" class="search-box-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <g>
                    <g>
                      <path
                        fill="#6E7077"
                        d="M14.108 7.054a7.054 7.054 0 1 0-2.609 5.477l5.255 5.255a.73.73 0 0 0 1.032-1.032L12.531 11.5a7.025 7.025 0 0 0 1.577-4.445zm-12.649 0a5.595 5.595 0 1 1 11.19 0 5.595 5.595 0 0 1-11.19 0z"
                      />
                    </g>
                  </g></svg
              ></a>
              <div class="search-box">
                <a class="close-btn" v-if="search" @click="search = ''"></a>
                <input
                  type="text"
                  v-model="search"
                  placeholder="Search..."
                  class="form-control"
                />
                <button></button>
              </div>
            </div>
            <div class="filter-tabs">
              <ul>
                <li class="pointer" :class="{ active: filterType === '' }">
                  <a @click.prevent="setFilterType('')"
                    ><span>All</span> {{ DocsData.count }}</a
                  >
                </li>
                <li
                  v-for="(eachCount, $index) in DocsData.counts"
                  :key="$index"
                  class="pointer"
                  :class="{
                    active: filterType === eachCount.entity_group,
                    'text-uppercase': eachCount.entity_group === 'Dax',
                  }"
                >
                  <a @click="setFilterType(eachCount.entity_group)">
                    <span v-if="eachCount.entity_group == 'Priorities Matrix'"
                      >Priorities</span
                    >
                    <span v-else>{{ eachCount.entity_group }}</span>
                    {{ eachCount.total }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <svg
          class="rotate-infinite mx-auto"
          v-if="!filteredItems || busy"
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="45"
          viewBox="0 0 18 15"
        >
          <g>
            <g>
              <path
                fill="#8e8e93"
                d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"
              />
            </g>
          </g>
        </svg>
        <template v-else-if="filteredItems.length">
          <div
            class="col-12 col-sm-6 col-md-3"
            v-for="(doc, $index) in filteredItems"
            :key="$index"
          >
            <div class="grid-card-box">
              <a :href="doc.entity_name" @click.prevent="goToApp(doc)">
                <div class="card-img">
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-if="doc.entity_name == 'Dax'"
                    style="
                      background-image: url('/assets/img/dax-thumbnail.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'MCode'"
                    style="
                      background-image: url('/assets/img/mcode-code-thumbnail.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'RAWCode'"
                    style="
                      background-image: url('/assets/img/raw-code-thumbnail.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'RCode'"
                    style="
                      background-image: url('/assets/img/rcode-code-thumbnail.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'PythonCode'"
                    style="
                      background-image: url('/assets/img/python-code-thumbnail.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'Notepad'"
                    style="
                      background-image: url('/assets/img/notepad-code-thumbnail.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'Planner'"
                    style="
                      background-image: url('/assets/img/planner-thumbnail.png');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'Priorities Matrix'"
                    style="
                      background-image: url('/assets/img/priority-thumbnail.png');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'Model Planner'"
                    style="
                      background-image: url('/assets/img/model_planner_thumbnail.png');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'Pipeline Planner'"
                    style="
                      background-image: url('/assets/img/pipeline_thumbnail.png');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'Playlist'"
                    style="
                      background-image: url('/assets/img/playlist_play.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="doc.entity_name == 'PowerBITheme'"
                    style="
                      background-image: url('/assets/img/power_bi_theme_thumb.svg');
                    "
                  ></a>
                  <a
                    class="card-img-bg"
                    href="javascript:;"
                    v-else-if="
                      doc.entity_name == 'Portfolio' &&
                      doc.portfolio.pictures &&
                      Object.values(doc.portfolio.pictures).length
                    "
                    :style="{
                      backgroundImage:
                        'url(' +
                        Object.values(doc.portfolio.pictures)[0].thumb +
                        ')',
                    }"
                  ></a>
                  <VerticalColourPalette
                    v-else-if="
                      doc.colour_generator && doc.colour_generator.meta.colours
                    "
                    v-bind:count="doc.colour_generator.meta.coloursAmount"
                    v-bind:colours="doc.colour_generator.meta.colours"
                  />
                  <a
                    class="card-img-bg"
                    v-else
                    href="javascript:;"
                    style="background-image: url('/assets/img/colours-pic.jpg')"
                  ></a>
                  <div class="card-hover-box">
                    <a
                      class="btn btn-sm-alternative-primary"
                      href="javascript:;"
                      >Open Document</a
                    >
                    <div class="card-hover-btn">
                      <div
                        class="card-btn delete-btn"
                        v-if="
                          !doc.team_shared ||
                          userData.team_role == 'owner' ||
                          userData.team_role == 'admin'
                        "
                      >
                        <a
                          onclick="return false"
                          @click="
                            markClickedAction();
                            deleteConfirm(doc.document_id);
                          "
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="18"
                            viewBox="0 0 15 18"
                          >
                            <g>
                              <g>
                                <path
                                  d="M9.75 7.5v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0zM6 6.75a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 6 6.75zm6.662-2.25H2.338l1.259 11.332a.75.75 0 0 0 .745.668h6.316a.75.75 0 0 0 .745-.667zM14.25 3a.75.75 0 0 1 0 1.5h-.079l-1.278 11.498A2.249 2.249 0 0 1 10.657 18H4.344a2.25 2.25 0 0 1-2.237-2.002L.829 4.5H.75a.75.75 0 0 1 0-1.5H4.5v-.75A2.25 2.25 0 0 1 6.75 0h1.5a2.25 2.25 0 0 1 2.25 2.25V3zm-7.5-1.5a.75.75 0 0 0-.75.75V3h3v-.75a.75.75 0 0 0-.75-.75z"
                                />
                              </g>
                            </g></svg
                        ></a>
                        <span
                          onclick="return false"
                          @click="
                            markClickedAction();
                            deleteConfirm(doc.document_id);
                          "
                          >Delete</span
                        >
                      </div>
                      <div class="card-btn copy-btn">
                        <a
                          href="javascript:;"
                          onclick="return false"
                          @click="
                            markClickedAction();
                            goToAppClone(doc);
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                          >
                            <g>
                              <g>
                                <path
                                  d="M6.23 14.308a2.538 2.538 0 0 1-2.538-2.539V5.077H2.407c-.565 0-1.022.457-1.022 1.022v8.44c0 1.147.93 2.076 2.077 2.076h8.44c.564 0 1.021-.457 1.021-1.022v-1.285zM6.23 0h9.232A2.538 2.538 0 0 1 18 2.538v9.231a2.538 2.538 0 0 1-2.538 2.539h-1.154v1.285A2.407 2.407 0 0 1 11.9 18h-8.44A3.462 3.462 0 0 1 0 14.538v-8.44a2.407 2.407 0 0 1 2.407-2.406h1.285V2.538A2.538 2.538 0 0 1 6.231 0zm0 1.385c-.636 0-1.153.516-1.153 1.153v9.231c0 .637.517 1.154 1.154 1.154h9.23c.638 0 1.154-.517 1.154-1.154V2.54c0-.638-.516-1.154-1.153-1.154z"
                                />
                              </g>
                            </g>
                          </svg>
                        </a>
                        <span
                          onclick="return false"
                          @click="
                            markClickedAction();
                            goToAppClone(doc);
                          "
                          >Copy</span
                        >
                      </div>
                      <div class="card-btn comment-btn pointer">
                        <a
                          onclick="return false"
                          @click="goToApp(doc, 'comments')"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="24"
                            viewBox="0 0 19 19"
                          >
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M5.784 9.773H12.3a.815.815 0 0 1 0 1.628H5.784a.815.815 0 0 1 0-1.628zM4.97 7.324c0-.446.365-.809.814-.809h2.443c.45 0 .815.363.815.81 0 .446-.365.809-.815.809H5.784a.812.812 0 0 1-.814-.81zM.084 8.958a8.958 8.958 0 1 1 4.645 7.854l-2.453 1.051c-1.352.58-2.718-.787-2.14-2.139l1.052-2.453A8.93 8.93 0 0 1 .084 8.958zm8.958-7.33a7.329 7.329 0 0 0-6.25 11.162l.221.359-1.379 3.217 3.217-1.379.36.22a7.329 7.329 0 0 0 11.16-6.25 7.329 7.329 0 0 0-7.33-7.328z"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </a>
                        <span
                          onclick="return false"
                          @click="goToApp(doc, 'comments')"
                          >Comments</span
                        >
                      </div>
                      <like-button
                        :viewMode="'list-card'"
                        :docId="doc.id"
                        :status="doc.liked"
                        :total_likes="doc.likes_count"
                        :index="$index"
                      ></like-button>
                    </div>

                    <div class="card-btn add-project copy-btn" v-if="!freePlan">
                      <a
                        onclick="return false"
                        @click="
                          markClickedAction();
                          $router.push({
                            name: 'Add Project Document',
                            query: { document_id: doc.document_id },
                          });
                        "
                      >
                        <svg
                          fill="none"
                          width="24"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                          ></path>
                        </svg>
                      </a>
                      <span
                        onclick="return false;"
                        @click="
                          markClickedAction();
                          $router.push({
                            name: 'Add Project Document',
                            query: { document_id: doc.document_id },
                          });
                        "
                        >Add to Project</span
                      >
                    </div>
                  </div>
                </div>
              </a>
              <div class="card-info">
                <div class="card-title">
                  <h3>
                    <img
                      src="/assets/img/file-icon.svg"
                      alt=""
                      v-if="doc.entity_name == 'Dax'"
                    />
                    <img
                      src="/assets/img/file-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'RCode'"
                    />
                    <img
                      src="/assets/img/file-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Notepad'"
                    />
                    <img
                      src="/assets/img/file-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'PythonCode'"
                    />
                    <img
                      src="/assets/img/file-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'MCode'"
                    />
                    <img
                      src="/assets/img/file-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'RAWCode'"
                    />
                    <img
                      src="/assets/img/planner-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Planner'"
                    />
                    <img
                      src="/assets/img/planner-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Model Planner'"
                    />
                    <img
                      src="/assets/img/planner-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Pipeline Planner'"
                    />
                    <img
                      src="/assets/img/priorities-grid-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Priorities Matrix'"
                    />
                    <img
                      src="/assets/img/priorities-grid-icon.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Portfolio'"
                    />
                    <img
                      src="/assets/img/playlist_small_play.svg"
                      alt=""
                      v-else-if="doc.entity_name == 'Playlist'"
                    />
                    <img src="/assets/img/picture-icon.svg" alt="" v-else />
                    <router-link
                      v-if="doc.entity_name == 'Dax'"
                      :to="{
                        name: doc.entity_name,
                        query: { id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'MCode'"
                      :to="{ name: 'M Code', query: { id: doc.document_id } }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'RCode'"
                      :to="{ name: 'RCode', query: { id: doc.document_id } }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'PythonCode'"
                      :to="{
                        name: 'PythonCode',
                        query: { id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Notepad'"
                      :to="{ name: 'Notepad', query: { id: doc.document_id } }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'RAWCode'"
                      :to="{ name: 'RAW Code', query: { id: doc.document_id } }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'PowerBITheme'"
                      :to="{
                        name: 'Power Bi Theme',
                        query: { id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'ColourFan'"
                      :to="{
                        name: 'Colours Fan',
                        query: { id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'ColourImage'"
                      :to="{
                        name: 'Image to Colours',
                        query: { id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'ColourPalette'"
                      :to="{
                        name: 'Colours Palette',
                        query: { id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Planner'"
                      :to="{
                        name: 'Analytics Planner',
                        params: { doc_id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Model Planner'"
                      :to="{
                        name: 'Data Model Planner',
                        params: { doc_id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Pipeline Planner'"
                      :to="{
                        name: 'Data Pipeline Planner',
                        params: { doc_id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Priorities Matrix'"
                      :to="{
                        name: 'Priorities Matrix',
                        params: { doc_id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Portfolio'"
                      :to="{
                        name: 'Project Share',
                        params: { doc_id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                    <router-link
                      v-else-if="doc.entity_name == 'Playlist'"
                      :to="{
                        name: 'Playlist',
                        params: { doc_id: doc.document_id },
                      }"
                      >{{ doc.name }}</router-link
                    >
                  </h3>
                  <span class="btn shared-btn" v-if="doc.team_shared"
                    >TEAM DOCUMENT</span
                  >
                  <span class="btn shared-btn" v-else-if="doc.shared"
                    >SHARED</span
                  >
                  <span class="btn private-btn" v-else>PRIVATE</span>
                </div>
                <div class="card-profile">
                  <div class="profile-author">
                    {{ doc.created_at | moment("D MMMM YYYY") }}
                  </div>
                  <div class="social-stats">
                    <span
                      ><img
                        src="/assets/img/bubble-icon.svg"
                        alt=""
                        width="18"
                      />{{ doc.comments_count }}</span
                    >
                    <span
                      :id="'card-like-icon' + $index"
                      :class="{ active: doc.liked }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="-1 -2 20 19"
                        style="width: 18px"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                stroke="#000"
                                stroke-width="1.5"
                                fill="#fff"
                                d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="m-0" :id="'likesCount' + $index">{{
                        doc.likes_count
                      }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <section
      class="non-app-page-width text-center vertical-center"
      v-if="filteredItems && !filteredItems.length && !search && !busy"
    >
      <div class="save-document-form">
        <h2>You didn't Save any Documents yet</h2>
        <p>
          Open the Apps center and start creating with the Analyst Hub's
          products.<br />We can't wait for you to start!
        </p>
      </div>
    </section>

    <delete-confirm v-if="confirm"></delete-confirm>
  </div>
</template>

<script>
import DocumentHttpService from "../services/DocumentHttpService";
import DeleteConfirm from "./DeleteConfirm";
import Avatar from "vue-avatar";
import LikeButton from "../components/partials/LikeButton";
import VerticalColourPalette from "../components/partials/VerticalColourPalette";
import ApiService from "../api/api.service";

export default {
  name: "Documents",
  components: {
    DeleteConfirm,
    Avatar,
    LikeButton,
    VerticalColourPalette,
  },
  data: function () {
    return {
      search: "",
      filterType: "",
      DocsData: [],
      origData: [],
      confirm: false,
      docId: null,
      busy: false,

      freePlan: false,
      userData: null,
      teamDocs: false,
      clickedApp: false,
    };
  },
  mounted() {
    this.clickedApp = false;

    const titleEl = document.querySelector("head title");
    titleEl.textContent = "Analyst Hub by Enterprise DNA";

    this.init();
    this.freePlan = this.userData.free_plan;
  },
  computed: {
    filteredItems() {
      if (this.DocsData.count) {
        return this.DocsData.data.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        return [];
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.query.doc_type && from.query.doc_type != to.query.doc_type) {
        this.teamDocs = to.query.doc_type != "personal";
      } else if (!to.query.doc_type) {
        if (this.userData.team_id) {
          this.teamDocs = true;
        }
      }
      this.getDocs();
    },
  },
  methods: {
    init(filterType) {
      // updated documents count etc.
      ApiService.setHeader();
      ApiService.get("api/user")
        .then(({ data }) => {
          window.localStorage.setItem("user", JSON.stringify(data));
        })
        .catch((error) => {
          throw new Error("failed to load user");
        });

      this.userData = JSON.parse(localStorage.getItem("user"));
      if (this.userData && this.userData.team_id) {
        this.teamDocs = true;
      } else {
        this.teamDocs =
          this.$route.query.doc_type &&
          this.$route.query.doc_type != "personal";
      }

      this.getDocs();
    },

    getDocs() {
      this.busy = true;
      this.docService = new DocumentHttpService();
      this.docService
        .getAll(this.teamDocs)
        .then(({ data }) => {
          this.DocsData = data;
          this.origData = JSON.parse(JSON.stringify(data));
          if (data.count > 3) {
            if (filterType) {
              this.DocsData.data = data.data.filter((item) => {
                return item.entity_group == filterType;
              });
            }
          }
          this.busy = false;
        })
        .catch(() => {
          this.busy = false;
        });
    },
    deleteConfirm(id) {
      this.docId = id;
      this.confirm = true;

      this.markClickedAction();
    },

    deleteDoc() {
      this.docService.delete(this.docId).then(({ data }) => {
        if (data.status) {
          this.init();
        }
      });
    },

    setFilterType(val) {
      this.filterType = val;
      if (this.filterType) {
        this.DocsData.data = this.origData.data.filter((item) => {
          return item.entity_group == this.filterType;
        });
      } else {
        this.DocsData.data = this.origData.data;
      }
    },

    checkFreePlan(latestThree) {
      return !this.freePlan || latestThree;
    },

    goToApp(doc, hash) {
      if (!this.clickedApp) {
        let to = {};
        if (doc.entity_name == "Dax") {
          to = { name: "Dax", query: { id: doc.document_id } };
        } else if (doc.entity_name == "MCode") {
          to = { name: "M Code", query: { id: doc.document_id } };
        } else if (doc.entity_name == "RAWCode") {
          to = { name: "RAW Code", query: { id: doc.document_id } };
        } else if (doc.entity_name == "RCode") {
          to = { name: "RCode", query: { id: doc.document_id } };
        } else if (doc.entity_name == "PythonCode") {
          to = { name: "PythonCode", query: { id: doc.document_id } };
        } else if (doc.entity_name == "Notepad") {
          to = { name: "Notepad", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourFan") {
          to = { name: "Colours Fan", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourFan") {
          to = { name: "Colours Fan", query: { id: doc.document_id } };
        } else if (doc.entity_name == "PowerBITheme") {
          to = { name: "Power Bi Theme", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourPalette") {
          to = { name: "Colours Palette", query: { id: doc.document_id } };
        } else if (doc.entity_name == "Planner") {
          to = {
            name: "Analytics Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Priorities Matrix") {
          to = {
            name: "Priorities Matrix",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Model Planner") {
          to = {
            name: "Data Model Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Pipeline Planner") {
          to = {
            name: "Data Pipeline Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Playlist") {
          to = { name: "Playlist", params: { doc_id: doc.document_id } };
        } else if (doc.entity_name == "Portfolio") {
          to = {
            name: "Document View",
            params: { document_id: doc.document_id },
          };
        }
        if (hash) {
          to.hash = "#comments";
        }
        this.clickedApp = true;
        console.log("to :>> ", to);
        this.$router.push(to);
      }
    },

    goToAppClone(doc) {
      let to = {};
      if (doc.entity_name == "Dax") {
        to = { name: "Dax", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "MCode") {
        to = { name: "M Code", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "RAWCode") {
        to = { name: "RAW Code", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "RCode") {
        to = { name: "RCode", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "PythonCode") {
        to = {
          name: "RPythonCode",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "Notepad") {
        to = { name: "Notepad", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "ColourFan") {
        to = {
          name: "Colours Fan",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "ColourImage") {
        to = {
          name: "Image to Colours",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "PowerBITheme") {
        to = {
          name: "Power Bi Theme",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "ColourPalette") {
        to = {
          name: "Colours Palette",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "Planner") {
        to = {
          name: "Analytics Planner",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Model Planner") {
        to = {
          name: "Data Model Planner",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Pipeline Planner") {
        to = {
          name: "Data Pipeline Planner",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Priorities Matrix") {
        to = {
          name: "Priorities Matrix",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Playlist") {
        to = {
          name: "Playlist",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Portfolio") {
        to = {
          name: "Document View",
          params: { document_id: doc.document_id },
          query: { clone: true },
        };
      }
      this.$router.push(to);
    },

    markClickedAction() {
      this.clickedApp = true;
      // reverting back
      setTimeout(() => {
        this.clickedApp = false;
      }, 300);
    },
  },
};
</script>

<style scoped>
.non-app-page-width,
.non-app-page-width .save-document-form {
  margin: auto;
}
.doc-types {
  margin-bottom: 30px;
}

.doc-types ul {
  list-style-type: none;
  margin-bottom: 0px;
  border-bottom: 1px solid #dfdfdf;
}

.doc-types ul li {
  display: inline-block;
  margin-right: 10px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.doc-types ul li.active {
  color: #1e73bd;
  border-bottom: 2px solid #1e73bd;
}

.add-project {
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 40px;
  height: 41px;
  /*box-shadow: 0 10px 41px rgba(0, 0, 0, 0.25);*/
  border-radius: 6px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-project:hover {
  border-radius: 6px 0 0 6px;
  background-color: #23a6cd;
}

.card-hover-box .add-project:hover span {
  left: 40px;
  width: 150px;
  opacity: 1;
  visibility: visible;
  border-radius: 0px 6px 6px 0px;
}

.card-hover-box .add-project:hover a {
  height: 24px;
}

.card-hover-box .add-project svg path {
  width: 24px;
  height: 24px;
  stroke: #000000;
  fill: #ffffff;
}

.card-hover-box .add-project:hover svg path {
  stroke: #ffffff;
  fill: #23a6cd;
}
</style>
